import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { topServices, poorPerformingServices, serviceStatusDistribution, channelUsage } from '../utils/mockData';
import { CheckCircleIcon, AlertCircleIcon, ClockIcon, XCircleIcon } from 'lucide-react';
const ServicePanel = ({
  filters
}) => {
  const COLORS = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444'];
  const STATUS_ICONS = {
    Completed: <CheckCircleIcon size={16} className="text-green-500" data-id="element-157" />,
    'In Progress': <ClockIcon size={16} className="text-blue-500" data-id="element-158" />,
    Pending: <AlertCircleIcon size={16} className="text-yellow-500" data-id="element-159" />,
    Rejected: <XCircleIcon size={16} className="text-red-500" data-id="element-160" />
  };
  return <div className="w-80 bg-slate-800 rounded-lg p-4 flex flex-col gap-4" data-id="element-161">
      <h2 className="text-xl font-semibold" data-id="element-162">Service Delivery</h2>
      {/* Top Services */}
      <div className="bg-slate-700 p-3 rounded-lg" data-id="element-163">
        <h3 className="text-sm font-semibold mb-3" data-id="element-164">Top Services by Volume</h3>
        <div className="h-48" data-id="element-165">
          <ResponsiveContainer width="100%" height="100%" data-id="element-166">
            <BarChart data={topServices} margin={{
            top: 5,
            right: 5,
            left: 0,
            bottom: 20
          }} data-id="element-167">
              <XAxis dataKey="name" tick={{
              fontSize: 10
            }} tickFormatter={value => value.split(' ')[0]} angle={-45} textAnchor="end" data-id="element-168" />
              <YAxis hide data-id="element-169" />
              <Tooltip formatter={value => [value.toLocaleString(), 'Requests']} labelFormatter={label => label} data-id="element-170" />
              <Bar dataKey="volume" fill="#3b82f6" data-id="element-171" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      {/* Services Needing Attention */}
      <div className="bg-slate-700 p-3 rounded-lg" data-id="element-172">
        <h3 className="text-sm font-semibold mb-2" data-id="element-173">
          Services Needing Attention
        </h3>
        <div className="text-xs" data-id="element-174">
          {poorPerformingServices.map((service, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-slate-600 last:border-0" data-id="element-175">
              <div data-id="element-176">{service.name}</div>
              <div className="flex items-center gap-2" data-id="element-177">
                <div className={`
                  ${service.sla >= 0.8 ? 'text-green-400' : service.sla >= 0.6 ? 'text-yellow-400' : 'text-red-400'}
                `} data-id="element-178">
                  {(service.sla * 100).toFixed(0)}% SLA
                </div>
                <div className="text-slate-400" data-id="element-179">{service.avgTime} days</div>
              </div>
            </div>)}
        </div>
      </div>
      {/* Service Status */}
      <div className="bg-slate-700 p-3 rounded-lg" data-id="element-180">
        <h3 className="text-sm font-semibold mb-2" data-id="element-181">Request Status</h3>
        <div className="flex" data-id="element-182">
          <div className="w-1/2 h-32" data-id="element-183">
            <ResponsiveContainer width="100%" height="100%" data-id="element-184">
              <PieChart data-id="element-185">
                <Pie data={serviceStatusDistribution} cx="50%" cy="50%" innerRadius={25} outerRadius={45} paddingAngle={2} dataKey="value" data-id="element-186">
                  {serviceStatusDistribution.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-187" />)}
                </Pie>
                <Tooltip formatter={value => [value.toLocaleString(), 'Requests']} labelFormatter={label => label} data-id="element-188" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="w-1/2 text-xs" data-id="element-189">
            {serviceStatusDistribution.map((item, index) => <div key={index} className="flex items-center gap-2 mb-2" data-id="element-190">
                <div className="flex items-center gap-1" data-id="element-191">
                  {STATUS_ICONS[item.status]}
                  <span data-id="element-192">{item.status}</span>
                </div>
                <div className="text-slate-400" data-id="element-193">
                  {(item.value / serviceStatusDistribution.reduce((acc, curr) => acc + curr.value, 0) * 100).toFixed(1)}
                  %
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {/* Channel Usage */}
      <div className="bg-slate-700 p-3 rounded-lg" data-id="element-194">
        <h3 className="text-sm font-semibold mb-2" data-id="element-195">Channel Usage</h3>
        <div className="text-xs" data-id="element-196">
          {channelUsage.map((channel, index) => <div key={index} className="mb-2" data-id="element-197">
              <div className="flex justify-between mb-1" data-id="element-198">
                <span data-id="element-199">{channel.channel}</span>
                <span data-id="element-200">
                  {(channel.value / channelUsage.reduce((acc, curr) => acc + curr.value, 0) * 100).toFixed(1)}
                  %
                </span>
              </div>
              <div className="w-full bg-slate-600 rounded-full h-1.5" data-id="element-201">
                <div className="h-1.5 rounded-full bg-blue-500" style={{
              width: `${channel.value / channelUsage.reduce((acc, curr) => acc + curr.value, 0) * 100}%`
            }} data-id="element-202"></div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default ServicePanel;